// Improvement row L10. The WordPress shortcode paints the desktop map placeholder
// from server HTML (`.rrm-ssr-map`, a sibling of the React root) so the largest
// contentful paint no longer waits for this bundle. Its CSS hides it as soon as
// `#r24-App-Main` exists (`:has()`); this removes the node after the widget's
// first painted frame for browsers without `:has()`, and frees it everywhere.
// Two animation frames: the first fires before the commit is painted, the
// second after — removing it earlier would leave the column blank for a frame.
export const SERVER_MAP_PLACEHOLDER = '.rrm-ssr-map';

export function retireServerMapPlaceholder(doc: Document = document): () => void {
    let frame = requestAnimationFrame(() => {
        frame = requestAnimationFrame(() => {
            doc.querySelectorAll(SERVER_MAP_PLACEHOLDER).forEach(node => node.remove());
        });
    });
    return () => cancelAnimationFrame(frame);
}
